(function () {
  const loop =
    $(".product-gallery.owl-carousel .product-gallery__item").length > 1;
  const autoplay =
    $(
      ".product-gallery.owl-carousel .product-gallery__item iframe, .product-gallery.owl-carousel .product-gallery__item video"
    ).length == 0;

  $(".product-gallery.owl-carousel").owlCarousel({
    items: 1,
    loop: loop,
    dots: true,
    autoplay: false,
    // autoplayTimeout:7000,
    // autoplayHoverPause:true
  });

  let count = 0;
  document.querySelectorAll(".sticky-section").forEach((el) => {
    if (el.querySelectorAll(".pdp-sticky__trigger").length) {
      count++;

      const align = count % 2 ? "right" : "left";
      el.classList.add("sticky-section--" + align);
    }
  });

  ScrollTrigger.matchMedia({
    "(min-width: 992px)": function () {
      const buttonsST = ScrollTrigger.create({
        trigger: "#product-hero",
        start: `${-140} top`,
        end: "bottom bottom",
        pin: ".button-group--sticky",
        scroller: ".smooth-scroll",
        pinSpacing: false,
      });
      window.buttonsST = buttonsST;

      // setInterval(() => {
      //   buttonsST.refresh();
      // }, 1000);
      const endTriggerElement = document.querySelector("#product-pair")
        ? "#product-pair"
        : "#shopify-section-footer";
      const subnavST = ScrollTrigger.create({
        start: "bottom top",
        end: "top bottom",
        trigger: "#product-hero",
        endTrigger: endTriggerElement,
        // pin: '.button-group--sticky',
        toggleClass: {
          targets: ".product-sub-header",
          className: "active",
        },

        scroller: ".smooth-scroll",
        pinSpacing: false,
      });

      /**
       * ScrollTrigger for sticky content/images
       */
      const triggers = document.querySelectorAll(".pdp-sticky__trigger");
      const lastIndex = triggers.length - 1;
      triggers.forEach((trigger, index) => {
        /**
         * -140 = navHeight + announcement bar, only on hero.
         * -100 on the rest of the sections
         */
        const navHeight = index == 0 ? 140 : 100;
        const imagePause = 350;
        const topOffset = -1 * navHeight;
        const bottomOffset =
          index == lastIndex ? "bottom" : navHeight - imagePause;

        $(".pdp-sticky__image-spacing").height(imagePause);
        const ST = ScrollTrigger.create({
          trigger: trigger,
          start: `${topOffset} top`,
          end: `bottom ${bottomOffset}`,
          pin: trigger.querySelector(".pdp-sticky__image"),
          scroller: ".smooth-scroll",
          pinSpacing: false,
        });
      });
    },
    "(max-width: 992px)": function () {
      const pdpnavST = ScrollTrigger.create({
        start: "top 112",
        end: "top 50%",
        trigger: ".pdp-nav",
        endTrigger: "#space-marker",
        pin: ".pdp-nav",
        // toggleClass: {
        //   targets: ".pdp-nav",
        //   className: "active"
        // },

        scroller: ".smooth-scroll",
        pinSpacing: false,
      });

      const classToggleST = ScrollTrigger.create({
        start: "top top+=200px",
        end: "bottom top",
        trigger: "body",
        endTrigger: ".product-main__form",
        toggleClass: {
          targets: "body",
          className: "hide--sticky-atc",
        },
      });

      // const subnavST = ScrollTrigger.create({
      //   start: 'top 100',
      //   end: 'top bottom',
      //   trigger: '.product-hero',
      //   endTrigger: '#shopify-section-footer',
      //   // pin: '.pdp-nav',
      //   toggleClass: {
      //     targets: ".product-sub-header",
      //     className: "active"
      //   },

      //   scroller: '.smooth-scroll',
      //   pinSpacing: false,
      // });
    },
  });

  $(".sub-nav-items > a").on("click", function (e) {
    e.preventDefault();
    const target = $($(this).attr("href"))[0];
    console.log(target);

    const offset = $(this).attr("data-offset") || -150;

    if (locoScroll) {
      locoScroll.scrollTo(target, {
        offset,
      });
    }
  });

  locoScroll.on(
    "scroll",
    _.debounce(
      function (args) {
        document.querySelectorAll(".sub-nav-items > a").forEach((link) => {
          const target = link.getAttribute("href").slice(1);

          if (typeof args.currentElements[target] === "object") {
            $(".sub-nav-items > a.active").removeClass("active");
            link.classList.add("active");
          }
        });
      },
      300,
      {
        maxWait: 300,
      }
    )
  );

  $(".product-main__more").on("click", function (e) {
    e.preventDefault();

    $(this)
      .closest(".product-main__description")
      .toggleClass("product-main__description--more");
    locoScroll.update();
    ScrollTrigger.refresh();
  });

  $(window).on("load", function () {
    ScrollTrigger.refresh();

    setTimeout(function () {
      ScrollTrigger.refresh();
    }, 1000);
  });

  $(".pdp-nav a").on("click", function (e) {
    e.preventDefault();
    const $tab = $($(this).attr("href"));
    const $this = $(this);

    locoScroll.scrollTo($(".product-hero").height() + 42, {
      callback: function () {
        $(".pdp-tab.active, .pdp-nav a.active").removeClass("active");
        $this.addClass("active");
        $tab.addClass("active");
      },
    });

    // ScrollTrigger.refresh();
  });
})();

function fadeCarousel() {
  if ($(".fade-carousel").length == 0) return;

  const tl = gsap.timeline({ repeat: -1, paused: true });

  document.querySelectorAll(".fade-carousel").forEach((carousel) => {
    const items = carousel.querySelectorAll(".item");
    const wrap = gsap.utils.wrap(Array.from(items));
    const duration = 5;

    items.forEach((item, index) => {
      tl.fromTo(
        wrap(index),
        {
          autoAlpha: 1,
        },
        {
          autoAlpha: 0,
        },
        `+=${duration}`
      ).fromTo(
        wrap(index + 1),
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1,
        }
      );
    });
  });

  tl.progress(1).play();
}
fadeCarousel();
